import { FC } from 'react'

import clsx from 'clsx'

import styles from './triangle.module.scss'

type Props = {
  className?: string
}

export const Triangle: FC<Props> = ({ className }) => {
  return <div className={clsx(styles.container, className)} />
}
